<template>
  <CCard>
  <CCardHeader>
    <slot name="header">
      <CIcon name="cil-grid" />Challenge Room
    </slot>
    <div class="float-right">
      <router-link :to="{ name: 'ChallengeCreate'}">
        <button class="btn btn-success">Create Challenge Room</button>
      </router-link>
    </div>
  </CCardHeader>
  <CCardBody></CCardBody>
  </CCard>
</template>

<script>
export default {
name: "ChallengeRoom"
}
</script>

<style scoped>

</style>